export default __webpack_public_path__ + "static/media/rewards-giveaways.df18cf41.png";